<template>
    <div>
        <Form v-model="sessionForm" label-position="top" class="fit-to-content">
            <Row :gutter="32" style="width: 800px;">
                <i-col span="12">
                    <Card shadow="">
                        <p slot="title">User</p>
                        <div>
                            <FormItem prop="user" label="Session timeout (mn)">
                                <InputNumber :min="5"
                                             v-model="sessionForm.user.sessionTtl"
                                             @on-change="updateTimeout('user','sessionTtl')"
                                             class="session-input"
                                             :disabled="submitLoading">
                                </InputNumber>
                            </FormItem>
                            <FormItem prop="user" label="No. of failed request before banned">
                                <InputNumber
                                             v-model="sessionForm.user.BanConsecutiveCounter"
                                             @on-change="updateTimeout('user','BanConsecutiveCounter')"
                                             class="session-input"
                                             :disabled="submitLoading">
                                </InputNumber>
                            </FormItem>
                            <FormItem prop="user" label="Ban duration (mn)">
                                <InputNumber
                                             v-model="sessionForm.user.BanDuration"
                                             @on-change="updateTimeout('user','BanDuration')"
                                             class="session-input"
                                             :disabled="submitLoading">
                                </InputNumber>
                            </FormItem>
                        </div>

                    </Card>
                </i-col>
                <i-col span="12">
                    <Card shadow>
                        <p slot="title">Administrator</p>
                       <div>
                           <FormItem prop="administrator" label="Session timeout (mn):">
                               <InputNumber :min="5"
                                            v-model="sessionForm.administrator.sessionTtl"
                                            @on-change="updateTimeout('administrator','sessionTtl')"
                                            class="session-input"
                                            :disabled="submitLoading">
                               </InputNumber>
                           </FormItem>
                           <FormItem prop="user" label="No. of failed request before banned">
                               <InputNumber
                                            v-model="sessionForm.administrator.BanConsecutiveCounter"
                                            @on-change="updateTimeout('administrator','BanConsecutiveCounter')"
                                            class="session-input"
                                            :disabled="submitLoading">
                               </InputNumber>
                           </FormItem>
                           <FormItem prop="user" label="Ban duration (mn)">
                               <InputNumber
                                            v-model="sessionForm.administrator.BanDuration"
                                            @on-change="updateTimeout('administrator','BanDuration')"
                                            class="session-input"
                                            :disabled="submitLoading">
                               </InputNumber>
                           </FormItem>
                       </div>
                    </Card>
                </i-col>
            </Row>
        </Form>
    </div>
</template>

<script>
    import {bus} from "../../main";
    import { getSessionTimeouts,updateSessionTimeouts } from '../../_services/sessions.service'
    export default {
        data(){
            return{
                sessionForm:{
                    administrator:{
                        sessionTtl:5,
                        BanConsecutiveCounter: 0,
                        BanDuration: 0
                    },
                    user:{
                        sessionTtl:5,
                        BanConsecutiveCounter: 0,
                        BanDuration: 0
                    },
                },
                currSessionData:{
                    administrator:{},
                    user:{},
                },
                submitLoading:false,
                timeout:{
                    administrator:{
                        sessionTtl:null,
                        BanConsecutiveCounter: null,
                        BanDuration: null
                    },
                    user:{
                        sessionTtl:null,
                        BanConsecutiveCounter: null,
                        BanDuration: null
                    },
                },

            }
        },
        components: {
        },
        methods: {
            getSessionTimeoutList(){
                getSessionTimeouts().then(res=>{
                    let adminSession=Object.assign({},res.data.data.filter(({role})=>{ return role=='administrator'})[0])
                    let userSession=Object.assign({},res.data.data.filter(({role})=>{ return role=='user'})[0])

                    this.sessionForm.administrator=adminSession
                    this.sessionForm.user=userSession

                    this.currSessionData.administrator=res.data.data.filter(({role})=>{ return role=='administrator'})[0]
                    this.currSessionData.user=res.data.data.filter(({role})=>{ return role=='user'})[0]

                }).catch(err=>{
                    bus.$emit('requestError',err)
                    this.$Message.error("Failed to retrieve session timeout data. Please try again later.");
                })
            },
            updateTimeout(role,field){
                let vm=this
                clearTimeout(vm.timeout[role][field]);
                vm.timeout[role][field] = setTimeout(function () {
                    let noticeTitle=""
                    let noticeDesc=""
                    updateSessionTimeouts(vm.sessionForm[role]).then(res => {
                        // if(role==="administrator") {
                        //     let msTimeout = vm.sessionForm[role].sessionTtl * 60000
                        //     bus.$emit('sessionTimeoutChanged', msTimeout);
                        // }
                        noticeTitle=`Update Successful`
                        if(field==='sessionTtl'){
                            noticeDesc=`Session timeout for ${role} successfully updated`
                        }
                        if(field==='BanConsecutiveCounter'){
                            noticeDesc=`No. of failed request before ban for ${role} successfully updated`
                        }
                        if(field==='BanDuration'){
                            noticeDesc=`Ban duration for ${role} successfully updated`
                        }
                        vm.$Notice.success({
                            title: noticeTitle,
                            desc: noticeDesc,
                        });

                    }).catch(err => {
                        bus.$emit('requestError',err)
                        vm.getSessionTimeoutList()
                        noticeTitle=`Failed to update`
                        if(field==='sessionTtl'){
                            noticeDesc=`Failed to update ${vm.sessionForm[role].role} Session timeouts. Please try again later.`
                        }
                        if(field==='BanConsecutiveCounter'){
                            noticeDesc=`Failed to update ${role} no. of failed request before ban.Please try again later.`
                        }
                        if(field==='BanDuration'){
                            noticeDesc=`Failed to update ${role} ban duration .Please try again later.`
                        }
                        vm.$Notice.error({
                            title: noticeTitle,
                            desc: noticeDesc,
                        });
                    })
                }, 700);
            },
        },
        mounted() {
            this.getSessionTimeoutList()
        }
    };
</script>

<style scoped>
    .session-input{
        width: 300px;
    }
</style>
